import React from 'react';
import { Button } from './ui/button';
import { Home, AlertTriangle } from 'lucide-react';

const NotFound = ({ onBack }) => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
            <div className="relative mb-8">
                <AlertTriangle className="h-24 w-24 text-yellow-500 animate-pulse" />
                <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-4xl font-black text-[#001524]">404</span>
            </div>
            <h1 className="text-4xl font-bold text-[#001524] mb-4">Page Not Found</h1>
            <p className="text-slate-400 max-w-md mb-8">
                Oops! The page you're looking for doesn't exist or has been moved.
                Let's get you back on track.
            </p>
            <Button
                onClick={onBack}
                className="bg-[#FF7D00] hover:bg-[#FF7D00]/90 text-white px-8 py-6 rounded-full text-lg font-bold flex items-center gap-2 transition-all hover:scale-105 shadow-lg shadow-orange-500/20"
            >
                <Home className="h-5 w-5" />
                Take Me Home
            </Button>
        </div>
    );
};

export default NotFound;
